import { flatbizDate } from '@flatbiz/utils';
import { PickerColumnItem, PickerColumnValue } from '../picker/types';

export const getYearList = (props: { minDate: string; maxDate: string }) => {
  const { y: minDateYear } = flatbizDate.detail(props.minDate);
  const { y: maxDateYear } = flatbizDate.detail(props.maxDate);

  const result = [] as PickerColumnItem[];
  for (let i = minDateYear; i <= maxDateYear; i++) {
    result.push({
      value: i,
      label: `${i}年`,
    });
  }
  return result;
};

export const getMonthList = (year: number, props: { minDate: string; maxDate: string }) => {
  const minDateInfo = flatbizDate.detail(props.minDate);
  const maxDateInfo = flatbizDate.detail(props.maxDate);
  const result = [] as PickerColumnItem[];
  let minMonth = 1;
  let maxMonth = 12;
  if (year === minDateInfo.y && year === maxDateInfo.y) {
    minMonth = minDateInfo.m;
    maxMonth = maxDateInfo.m;
  } else if (year === minDateInfo.y) {
    minMonth = minDateInfo.m;
  } else if (year === maxDateInfo.y) {
    maxMonth = maxDateInfo.m;
  }
  for (let i = minMonth; i <= maxMonth; i++) {
    result.push({
      value: i,
      label: `${i}月`,
    });
  }
  return result;
};

export const getDayList = (year: number, month: number, props: { minDate: string; maxDate: string }) => {
  const minDateInfo = flatbizDate.detail(props.minDate);
  const maxDateInfo = flatbizDate.detail(props.maxDate);
  const result = [] as PickerColumnItem[];
  let maxDay = new Date(year, month, 0).getDate();
  let minDay = 1;
  if (year === maxDateInfo.y && month === maxDateInfo.m) {
    maxDay = maxDateInfo.d;
  }

  if (year === minDateInfo.y && month === minDateInfo.m) {
    minDay = minDateInfo.d;
  }

  for (let i = minDay; i <= maxDay; i++) {
    result.push({
      value: i,
      label: `${i}日`,
    });
  }
  return result;
};

export const targetValueInDateItemList = (
  dateItemList: PickerColumnItem<PickerColumnValue>[],
  targetValue: number,
) => {
  return (
    targetValue >= Number(dateItemList[0].value) &&
    targetValue <= Number(dateItemList[dateItemList.length - 1].value)
  );
};

export const latelyDateItemValue = (
  dateItemList: PickerColumnItem<PickerColumnValue>[],
  targetValue: number,
) => {
  const maxValue = dateItemList[dateItemList.length - 1].value as number;
  const minValue = dateItemList[0].value as number;
  return Math.abs(targetValue - minValue) - Math.abs(targetValue - maxValue) > 0 ? maxValue : minValue;
};
